import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { RadioConfig } from '../../../model';

/**
 * * Componente para um conjunto de Radio Buttons.
 */
@Component({
  selector: 'ui-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss']
})
export class RadioComponent implements OnInit {

  /**
   * * Título para o Radio Button.
   */
  @Input() title: string = '';
  /**
   * * Name para os elementos de Radio Button.
   */
  @Input() name: string = '';
  /**
   * * Valor Selecionado.
   */
  @Input() selectedValue: string = '';
  /**
   * * Lista de Configurações para o Radio Button.
   */
  @Input() options: RadioConfig[] = [];

  /**
   * * Evento ao selecionar Radio, enviando o valor selecionado.
   */
  @Output() emitter = new EventEmitter<string>();

  emitOption(value: string) {
    this.emitter.emit(value);
  }

  constructor() { }

  ngOnInit() {}
  
}
